/* Native disclosures work before JS loads and reconnect after Shopify section edits. */
if (!customElements.get('nny-site-header')) {
  customElements.define('nny-site-header', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.cleanup();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.panels = [...this.querySelectorAll('.nh-disclosure')];
      this.panels.forEach(panel => {
        panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
        panel.addEventListener('toggle', () => {
          panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
          if (!panel.open) return;
          this.panels.forEach(other => { if (other !== panel) other.open = false; });
          if (panel.hasAttribute('data-header-search')) panel.querySelector('input')?.focus();
        }, options);
      });
      this.addEventListener('click', event => {
        if (event.target.closest('a')) this.close();
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('keydown', event => {
        const open = this.panels.find(panel => panel.open);
        if (event.key === 'Escape' && open) {
          this.close();
          open.querySelector('summary').focus();
          return;
        }
        const target = event.target;
        const editing = target instanceof HTMLElement && (target.isContentEditable || target.closest('input, textarea, select, [role="textbox"]'));
        if (editing || event.altKey) return;
        if (event.key !== '/' && !((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k')) return;
        const desktopInput = this.querySelector('.nh-desktop-search input');
        if (desktopInput?.getClientRects().length) {
          event.preventDefault();
          this.close();
          desktopInput.focus();
        } else {
          const search = this.querySelector('[data-header-search]');
          if (search?.getClientRects().length) {
            event.preventDefault();
            search.open = true;
          }
        }
      }, options);
      ['(min-width: 768px)', '(min-width: 1024px)'].forEach(query => {
        matchMedia(query).addEventListener('change', () => this.close(), options);
      });
      const group = this.closest('#header-group');
      this.observer = new ResizeObserver(() => {
        if (group) this.style.setProperty('--nh-group-height', `${Math.ceil(group.getBoundingClientRect().height)}px`);
      });
      this.observer.observe(group || this);
    }

    close() {
      this.panels?.forEach(panel => {
        panel.open = false;
        panel.querySelector('summary').setAttribute('aria-expanded', 'false');
      });
    }

    cleanup() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.observer?.disconnect();
    }

    disconnectedCallback() { this.cleanup(); }
  });
}
